/**
 * AUTO-GENERATED by `npm run plugin -- sync`. DO NOT EDIT BY HAND.
 *
 * Regenerated from external-plugins.json + the keeptrack-plugin.json of each
 * clone under src/plugins-external/. Committed so a fresh checkout typechecks
 * and builds without running any tool; empty upstream when no external plugins
 * are installed.
 *
 * - `externalPluginManifest` is spread onto the end of `pluginManifest`, giving
 *   each external plugin its own async chunk exactly like a built-in.
 * - `externalPluginMeta` is read by the in-app Plugin Manager UI so it can list
 *   installed external plugins (version, repo, compat) without fetching anything
 *   at runtime. `compatible` is precomputed at sync time against the host
 *   package.json version.
 */
import type { PluginDescriptor } from './plugin-descriptor';

export interface ExternalPluginMetaEntry {
  /** npm-style package name from keeptrack-plugin.json `name`. */
  packageName: string;
  /** Plugin's own semver. */
  version: string;
  /** Repository URL for the "view source" link. */
  repoUrl: string;
  /** One-line description. */
  description: string;
  /** Declared engine compatibility range (semver). */
  engine: string;
  /** Resolved git commit the clone is pinned to. */
  commit: string;
  /** Precomputed at sync time: does `engine` satisfy the host version? */
  compatible: boolean;
}

export const externalPluginManifest: PluginDescriptor[] = [];

export const externalPluginMeta: Record<string, ExternalPluginMetaEntry> = {};
